const PatientSignatureImage = ({ signature, label, signedDate }) => {
    return (
        <div className="mb-4 flex flex-col sm:flex-row sm:items-start gap-6">
            {/* Signature Image */}
            <div className="flex-shrink-0">
                <label className="block text-base text-black mb-3">
                    {label}
                </label>
                {signature ? (
                    <img
                        src={signature}
                        alt={label}
                        loading="eager"
                        style={{
                            width: '300px',
                            height: '100px',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            borderRadius: '0.375rem',
                            border: '1px solid #D1D5DB',
                            objectFit: 'contain',
                            display: 'block',
                        }}
                    />
                ) : null}
            </div>

            {/* Date & Time */}
            <div className="mb-4 flex flex-col sm:flex-row flex-wrap gap-4 items-center">
                <p className="font-roboto text-base text-black whitespace-nowrap mx-1">
                    {signedDate}
                </p>
            </div>
        </div>
    );
};

export default PatientSignatureImage;
